import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconWallet5: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="wallet-5"><path d="M21.25 9V4.75H2.75V19.25H21.25V15" stroke="currentColor" strokeWidth="1.5"/><path d="M22.25 9.75H14.75V14.25H22.25V9.75Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconWallet5;
